<template>
  <div class="serviceArea">

    <div class="serviceArea-title">
      服务范围
    </div>
    <div class="serviceArea-font">平台支持83家船公司的VGM发送，清单如下：</div>
    <div class="flex">
      <div>
        <WTable :WTableOpts="WTableOpts">
        </WTable>
      </div>
      <div style="margin: 0 48px">
        <WTable :WTableOpts="WTableOpts1">
        </WTable>
      </div>
      <div>
        <WTable :WTableOpts="WTableOpts2">
        </WTable>
      </div>
    </div>
  </div>
</template>

<script>
import {serviceArea} from "@/utils/enum";

export default {
  name: "serviceArea",
  components: {

  },
  data(){
    return {
      WTableOpts: {
        data: serviceArea.allPorts,
        tableAttrs: {},
        tableColAttrs: [
          { label: "船公司",prop:"vesselName",width: '221px'},
          {  label: "支持口岸",prop:"ports",width: '221px'},
        ],
      },
      WTableOpts1: {
        data: serviceArea.shanghai,
        tableAttrs: {},
        tableColAttrs: [
          { label: "船公司",prop:"vesselName",width: '221px'},
          {  label: "支持口岸",prop:"ports",width: '221px'},
        ],
      },
      WTableOpts2: {
        data: serviceArea.outerPort,
        tableAttrs: {},
        tableColAttrs: [
          { label: "船公司",prop:"vesselName",width: '221px'},
          {  label: "支持口岸",prop:"ports",width: '221px'},
        ],
      },
    }
  },
  methods:{

  }
};
</script>
<style scoped lang="less">
.serviceArea {
  font-size: 14px;
  background: #ffffff;
  border-radius: 4px;
  padding: 24px;
  color: #333333;
  height: 100%;
  overflow-x: auto;
  .serviceArea-title {
    background: linear-gradient(90deg, #eaf4fe 0%, rgba(198, 225, 253, 0) 100%);
    border-radius: 4px;
    padding: 8px 16px;
    color: #333333;
  }
  .serviceArea-font {
    margin-top: 24px;
    margin-bottom: 16px;
  }
}
</style>
